import React from 'react'
import { Script } from '@s4l/react-facade'

const GoogleAdManager = () => {
  return (
    <>
      <Script
        id="google-ad-manager"
        strategy="afterInteractive"
        src="https://securepubads.g.doubleclick.net/tag/js/gpt.js"
      />
      <Script id="google-ad-manager-init" strategy="afterInteractive">
        {`
          window.googletag = window.googletag || {cmd: []};
          googletag.cmd.push(function() {
            googletag.pubads().enableSingleRequest();
            googletag.pubads().disableInitialLoad();
            googletag.enableServices();
          });
        `}
      </Script>
    </>
  )
}

GoogleAdManager.displayName = 'GoogleAdManager'

export default GoogleAdManager
